<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">All Budget Requests</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Budget Request" iconPos="left"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" [autoLayout]="true" responsiveLayout="scroll" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Budget Code<p-sortIcon field="code"></p-sortIcon></th>
            <th>Description</th>
            <th>Transaction name</th>
            <th>Name Type Count</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td><a>821010</a></td>
            <td>Withholding Tax Expenses</td>
            <td>Withholding Tax Expenses -Request</td>
            <td>7 : SBU Type</td>
            <td style="text-align: right;">
                <button pButton pRipple type="button" icon="pi pi-plus" label="Request Budget" (click)="showBasicDialog()"></button>
            </td>
        </tr>
    </ng-template>
</p-table>
</div>


<p-dialog header="Budget Request" [(visible)]="displayBasic" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Add your remark</label>
        <textarea rows="5" cols="30" pInputTextarea></textarea>
    </div>
    <div class="d-flex flex-column mb-3">
        <label class="mb-2">Amount</label>
        <input type="text" pInputText> 
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Month and Year</label>
        <div style="position: relative;">
            <p-calendar [(ngModel)]="rangeDates" placeholder="Select Date" selectionMode="range" [readonlyInput]="true" inputId="range" style="width:100%;"></p-calendar>  
            <div style="height:24px; width:24px; position: absolute; top:6px; right: 12px;" class="d-flex align-items-center justify-content-center">
                <i class="pi pi-calendar"></i>
            </div>
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Request" iconPos="left"  class="me-3"></button>
        <button pButton type="button" label="Cancel"  class="p-button-outlined"></button>
    </ng-template>
</p-dialog>


